"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricingResourceClient = void 0;
var _index = _interopRequireDefault(require("axios/index"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PricingResourceClient = /*#__PURE__*/function () {
  function PricingResourceClient() {
    var axiosInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, PricingResourceClient);
    this.axiosInstance = axiosInstance || _index["default"];
  }

  /**
   * @param {String} accessToken
   * @param {String} itemId
   * @param {String|undefined} associationTypes Comma-separated values, refer to https://developer.cimpress.io/apis/finance/price-association-service#/Price%20Associations/get_v1_priceAssociations
   * @return {Promise<PriceAssociationsResponse>}
   */
  _createClass(PricingResourceClient, [{
    key: "getPriceAssociations",
    value: function () {
      var _getPriceAssociations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accessToken, itemId) {
        var associationTypes,
          url,
          response,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                associationTypes = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
                url = "https://pas.cimpress.io/v1/priceAssociations?associationTargetType=items&associationTargetResourceNames=".concat(itemId);
                if (associationTypes) {
                  url += "&associationTypes=".concat(associationTypes);
                }
                _context.next = 5;
                return this.axiosInstance.get(url, {
                  headers: {
                    'Authorization': "Bearer ".concat(accessToken)
                  }
                });
              case 5:
                response = _context.sent;
                return _context.abrupt("return", response.data);
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getPriceAssociations(_x, _x2) {
        return _getPriceAssociations.apply(this, arguments);
      }
      return getPriceAssociations;
    }()
  }, {
    key: "getResourceByHref",
    value: function () {
      var _getResourceByHref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accessToken, href) {
        var sourceResponse;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.axiosInstance.get(href, {
                  headers: {
                    'Authorization': "Bearer ".concat(accessToken)
                  }
                });
              case 2:
                sourceResponse = _context2.sent;
                return _context2.abrupt("return", sourceResponse.data);
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getResourceByHref(_x3, _x4) {
        return _getResourceByHref.apply(this, arguments);
      }
      return getResourceByHref;
    }()
  }]);
  return PricingResourceClient;
}();
exports.PricingResourceClient = PricingResourceClient;